import * as React from "react";

export const IconExpandMore = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="currentColor" {...props}>
    <path d="M13.825 7.65833L10 11.475L6.175 7.65833L5 8.83333L10 13.8333L15 8.83333L13.825 7.65833Z" fill="currentColor" />
  </svg>
);
